export default __webpack_public_path__ + "static/media/paypal.655c9a6b.png";